
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { Mail } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

interface TestEmailButtonProps {
  collectionId: string;
  disabled?: boolean;
}

export const TestEmailButton = ({ collectionId, disabled }: TestEmailButtonProps) => {
  // Return null to hide the button completely
  return null;
};
